import React, { lazy, Suspense } from 'react';
const Board = /*#__PURE__*/lazy(() => import('./variants/Board/Board.js'));
function DragAndDrop(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(Board, props));
}
export default DragAndDrop;